export type CustomerAttributes = {
  hasOffers: string;
  offerBrands: string;
  totalRewardValue: string;
  mtlTotalRewardValue: string;
};

type ShippingAttributes = {
  countryName: string;
  countryFlagURL: string;
};

type BrandCode = 1 | 2 | 3 | 5 | 6;

type BounceBackText = "GapCash" | "Style Notes" | "Super Cash" | "StyleCash";

type Coordinates = {
  latitude: string;
  longitude: string;
};

export const getShippingAttributes = ({
  globalShippingCountryCode = "",
}): ShippingAttributes => ({
  countryName: "",
  countryFlagURL: `${globalShippingCountryCode.toLowerCase()}.gif`,
});

export const getBounceBackText = (currentBrand: BrandCode): BounceBackText => {
  const bounceBackText: {[key in BrandCode]: BounceBackText} = {
    1: "GapCash",
    2: "Style Notes",
    3: "Super Cash",
    5: "GapCash",
    6: "StyleCash",
  };
  return bounceBackText[currentBrand];
};

export const onOfferBrand = (
  offerBrands: string,
  currentMarketAgnosticBrandID: number
): boolean => {
  const offerBrandIds = offerBrands.split(",");
  return offerBrandIds.includes(String(currentMarketAgnosticBrandID));
};

export const hasBounceBack = (
  customerAttributes: CustomerAttributes,
  marketAgnosticBrandCode: number
): boolean => {
  const hasOffers = customerAttributes.hasOffers === "true";
  return (
    hasOffers &&
    onOfferBrand(customerAttributes.offerBrands, marketAgnosticBrandCode)
  );
};

export const hasRewards = (customerAttributes: CustomerAttributes): boolean => {
  const totalRewardValue = parseInt(
    customerAttributes.totalRewardValue || "0",
    10
  );
  const mtlTotalRewardValue = parseInt(
    customerAttributes.mtlTotalRewardValue || "0",
    10
  );

  return totalRewardValue + mtlTotalRewardValue > 0;
};

export const getCoordinates = (geoLocation = ""): Coordinates => {
  try {
    return {
      latitude:
        geoLocation
          ?.match(/lat=.*?(?=,)/g)
          ?.shift()
          ?.split("=")
          .pop() || "",
      longitude:
        geoLocation
          ?.match(/long=.*?(?=,)/g)
          ?.shift()
          ?.split("=")
          .pop() || "",
    };
  } catch (err) {
    return {
      latitude: "",
      longitude: "",
    };
  }
};

export const getZipCode = (
  geoLocation: string,
  zipOverride: string
): string => {
  if (zipOverride) {
    return zipOverride;
  }

  try {
    return (
      geoLocation
        ?.match(/zip=.*?(?=(,|\+))/g)
        ?.shift()
        ?.split("=")
        .pop() || ""
    );
  } catch (err) {
    return "";
  }
};
